module.exports = __webpack_public_path__ + "static/media/fly0143.a99ca831.webp";